
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-tab-manager-extensions",
      function () {
        return require("private-next-pages/best-tab-manager-extensions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-tab-manager-extensions"])
      });
    }
  